// src/hooks/useCreatePractice.js
import { useDispatch, useSelector } from 'react-redux';
import { createPractice } from '../../redux/practice/practiceSlice';
import { useCallback } from 'react';
import { RootState } from '../../redux';
import { CreatePracticePayload } from '../../types/Practice';

/**
 * Custom hook to encapsulate dispatching the createPractice thunk
 * and reading loading / error / result from Redux state.
 */
export default function useCreatePractice() {
  const dispatch = useDispatch();
  const { practice, isLoading, error } = useSelector((state: RootState) => state.practices);
  // A memoized function to dispatch createPractice
  const create = useCallback(
    (practiceData: CreatePracticePayload) => {
      dispatch(createPractice(practiceData) as any);
    },
    [dispatch]
  );

  return {
    create,
    practice,
    isLoading,
    error,
  };
}



